import classnames from 'classnames';
import s from './index.module.scss';

export const ProgressBar = ({ value, text, risky }) => {
  return (
    <div className={s.wrapper}>
      <div
        className={classnames(
          s.bar,
          value >= 100 && s.bar__completed,
          risky && s.bar__risky,
        )}
        style={{ width: `${parseInt(value) || 0}%` }}
      >
        <span className={classnames(s.bar__value, 'f-small-accent')}>
          {text ? text : `${parseInt(value)}%`}
        </span>
      </div>
    </div>
  );
};